import "./Pill.css";
import { ChevronRight, ExpandMore } from "@mui/icons-material";
import { useState } from "react";

export default function Pill({
  className,
  text,
  color,
  selected,
  useSelection = false,
}) {
  const variantEnum = { green: "green", red: "red", yellow: "yellow" };
  const [variantID] = useState(variantEnum[color] || "default");
  const variants = [
    {
      id: "default",
      color: "var(--color-leano-1)",
      backgroundColor: "white",
    },
    {
      id: "green",
      color: "var(--color-success-1)",
      backgroundColor: "var(--color-success-2)",
    },
    {
      id: "red",
      color: "var(--color-error-1)",
      backgroundColor: "var(--color-error-2)",
    },
    {
      id: "yellow",
      color: "var(--color-warning-1)",
      backgroundColor: "var(--color-warning-2)",
    },
  ];
  return (
    <span
      className={["Pill", className].filter(Boolean).join(" ")}
      style={{
        borderColor: variants.filter((variant) => variant.id === variantID)[0]
          .color,
        color: variants.filter((variant) => variant.id === variantID)[0].color,
        backgroundColor: variants.filter(
          (variant) => variant.id === variantID,
        )[0].backgroundColor,
        cursor: useSelection ? "pointer" : "unset",
      }}
    >
      {text}
      {useSelection ? (
        !selected ? (
          <ChevronRight style={{ fontSize: "small" }} />
        ) : (
          <ExpandMore style={{ fontSize: "small" }} />
        )
      ) : null}
    </span>
  );
}
